// extracted by mini-css-extract-plugin
export default {"actionListOverrides":"RelationshipsSection-module__actionListOverrides__ocVPsfz","groupHeading":"RelationshipsSection-module__groupHeading__HnUfEBa"};